export default "__VITE_ASSET__DADLzho1__"